<template>
    <form-modal :value="modal" @input="close"
        :title="$t('sessions.file-reopening')"
        size="lg"
        :centered="false"
    >
        <validation-observer v-slot="{ invalid, handleSubmit }" ref="reopenValidator">
            <form @submit.prevent="handleSubmit(submit)" @keydown="errors.clear($event.target.name)">

                <base-input class="mb-3"
                    :label="$t('sessions.reopen-file-reason')"
                    label-classes="form-control-label required"
                    rules="required"
                    name="comment"
                    :error="errors.get('comment')"
                >
                    <textarea class="form-control" rows="5"
                        :placeholder="$t('dashboard.enter-comment-here')"
                        v-model="comment"
                    >
                    </textarea>
                </base-input>

                <div class="category form-category mb-4">
                    <small><span class="text-warning">*</span> {{ $t('common.required-fields') }}</small>
                </div>

                <div class="text-center">
                    <base-button native-type="submit"
                        type="primary"
                        :loading="recording"
                        :disabled="errors.any() || invalid"
                    >
                        {{ $t('sessions.reopen') }}
                    </base-button>

                    <base-button type="link" class="ml-auto" @click="close">
                        {{ $t('common.cancel') }}
                    </base-button>
                </div>

            </form>
        </validation-observer>
    </form-modal>
</template>

<script>
    import FormErrors from '@trax/classes/FormErrors'

    export default {
        
        model: {
            prop: 'modal',
            event: 'input'
        },
        
        props: {

            modal: {
                type: Object,
                required: true
            },

            endpoint: {
                type: String,
                required: true
            }
        },

        data() {

            return {
                recording: false,
                comment: null,
                errors: new FormErrors(),
            }
        },

        created() {
            this.errors.setValidator('reopenValidator', this)
        },

        watch: {
            modal(val) {
                if (val.show) {
                    // The modal has just been opened. (Re)initialize the comment.
                    this.comment = null
                }
            }
        },

        methods: {

            submit() {
                this.recording = true
                axios.post(this.endpoint, { comment: this.comment })
                    .then(resp => {
                        this.recording = false
                        this.close()
                        this.$emit('change')
                    })
                    .catch(err => {
                        this.$auth.handleErrorVm(err, this)
                    })        
            },

            close() {
                this.$emit('input', {
                    show: false,
                })
            }
        }
    }
</script>